import { ICreateSendClaimPageState } from '../types/createSendClaimPage';

export const DEFAULT_CREATE_SEND_CLAIM_PAGE_STATE: ICreateSendClaimPageState = {};
